import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "remove-from-language-group-modal" */'./RemoveFromLanguageGroupModal').then(mod => mod.default),
  LoadingComponent: () => null
});